import { FEATURES } from '/src/features/_global/constants';

export const AUDIT_LOG_PERMISSIONS = {
  [FEATURES.AUDIT_LOG]: ({ capabilities }) => ({
    navigate: capabilities?.auditLog.permissions.nav,
    view: capabilities?.auditLog.permissions.view,
  }),
};
